var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "search-box" },
    [
      _c(
        "a-radio-group",
        {
          staticClass: "mode-toggle",
          attrs: { size: "small" },
          on: { change: _vm.onModeChange },
          model: {
            value: _vm.mode,
            callback: function ($$v) {
              _vm.mode = $$v
            },
            expression: "mode",
          },
        },
        [
          _c("a-radio-button", { attrs: { value: "goods" } }, [_vm._v("商品")]),
          _c("a-radio-button", { attrs: { value: "member" } }, [
            _vm._v("会员"),
          ]),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "input-wrap" },
        [
          _c("a-input", {
            ref: "input",
            staticClass: "search-input",
            attrs: { placeholder: _vm.placeholder, allowClear: "" },
            on: {
              input: _vm.onInput,
              keydown: _vm.onKeydown,
              focus: function ($event) {
                _vm.focused = true
              },
              blur: _vm.onBlur,
            },
            model: {
              value: _vm.keyword,
              callback: function ($$v) {
                _vm.keyword = $$v
              },
              expression: "keyword",
            },
          }),
          _vm.focused && _vm.candidates.length
            ? _c(
                "div",
                { staticClass: "dropdown" },
                _vm._l(_vm.candidates, function (c, i) {
                  return _c(
                    "div",
                    {
                      key: c.key,
                      staticClass: "drop-item",
                      class: { active: i === _vm.highlight },
                      on: {
                        mousedown: function ($event) {
                          $event.preventDefault()
                          return _vm.pick(i)
                        },
                        mouseenter: function ($event) {
                          _vm.highlight = i
                        },
                      },
                    },
                    [
                      _c("span", {
                        staticClass: "drop-name",
                        domProps: { innerHTML: _vm._s(c.label) },
                      }),
                      _c("span", { staticClass: "drop-sub" }, [
                        _vm._v(_vm._s(c.sub)),
                      ]),
                    ]
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }